const FacilitiesSection = () => {
  const facilities = [
    {
      title: 'レントゲン室',
      image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/f5c58efb42464ad98215c655e04067f2.jpeg',
    },
    {
      title: '治療室',
      image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/d563520a5875e4d605f32243b549295d.jpeg',
    },
    {
      title: '治療室',
      image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/2294347d95d904dc5c69ed9cf578be2a.jpeg',
    },
    {
      title: '診察室',
      image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/d65a6b655faf4585c0cc4ae0acadd299.jpeg',
    },
  ];

  return (
    <section className="py-20 lg:py-32 bg-white px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900">
            院内設備
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {facilities.map((facility, index) => (
            <div key={index} className="group">
              <div className="rounded-2xl overflow-hidden shadow-lg w-full h-[400px]">
                <img
                  src={facility.image}
                  alt={facility.title}
                  className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mt-6 text-center">
                {facility.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FacilitiesSection;